import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Add Place route
 *
 * @namespace routes.AdminPlacesAdd
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.places.add',
  params: {
    hierarchy: null,
    submitAndContinue: null,
  },
}

/**
 * Place add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminPlaceForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminPlaceFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminPlaceForm}.
 *
 * @type {ngController}
 */
export class tmrAdminPlaceFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    Hierarchy,
    tmrPlaceTypes,
    tmrZoneTypes,
    Zone
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { Hierarchy, tmrPlaceTypes, tmrZoneTypes, Zone })
  }

  $onInit() {
    super.$onInit()

    /** Set default value for automaticZoneCreation. True only if is ADD mode */
    this.automaticZoneCreation = this.op == 'add'

    //Set hierarchy default value
    if (this.$stateParams.hierarchy) {
      this.resource.hierarchy = this.$stateParams.hierarchy
      this.hierarchyText = this.$stateParams.hierarchy.description
    }
  }

  /** Query to get hierarchies for md-autocomplete */
  getHierarchies(value) {
    return this.Hierarchy.search({ value }).$promise
  }

  /** Override save */
  save() {
    return this.resource.$save().then(() => this.saveZone())
  }

  /**
   * If `this.automaticZoneCreation` is true, we need to create zones.
   */
  saveZone() {
    if (this.automaticZoneCreation) {
      // Create one zone for each zone type.
      return Promise.all(
        Object.keys(this.tmrZoneTypes).map(zoneType =>
          this.Zone.create({
            code: this.resource.code + '-' + zoneType.toLowerCase(),
            zoneType,
            description:
              this.resource.description + ' - ' + this.tmrZoneTypes[zoneType],
            place: { id: this.resource.id },
          }).$save()
        )
      )
    } else return Promise.resolve()
  }

  /** Override onSavedContinue callback */
  onSavedContinue() {
    return this.$state
      .go(
        this.$state.current,
        { hierarchy: this.resource.hierarchy, submitAndContinue: true },
        { reload: true, inherit: false }
      )
      .then(this.TmrToast.success(this.toast))
  }
}
